<template>
  <app-page title="EllaFashion">
    <div>
      <v-ons-card class="error" v-if="error">
        {{ error }}
      </v-ons-card>
      <v-ons-card class="active" v-if="pending">
        <img src="../assets/transmit.gif" style="float: left; margin-top: -4px; max-height: 1.5rem">
        <span style="margin-left: -1.5rem">{{pending}} pending updates</span>
      </v-ons-card>
      <!--div class="buttons"-->
      <v-ons-card>
        <v-ons-button @click="$router.push('/add')">Add labels</v-ons-button>
        <v-ons-button @click="$router.push('/del')">Remove labels</v-ons-button>
        <v-ons-button @click="$router.push('/label')">Check label</v-ons-button>
        <v-ons-button @click="$router.push('/product/')">Check product</v-ons-button>
        <v-ons-button v-if="this.pages.length > 1" @click="turnPagePopup()">Turn page</v-ons-button>
      </v-ons-card>
    </div>
  </app-page>
</template>

<script>
import util from '../util';

export default {
  data: () => ({ 
    timer: null,
    pending: 0,
    error: null,
    pages: []
  }),

  created() {
    this.timer = setInterval(this.updatePending, 10000);
    this.updatePending();
    this.checkPages();
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },
  
  methods: {
    async updatePending() {
      try {
        const status = await this.$api.status();
        this.pending = status.pending;
        this.error = null;
      } catch (e) {
        this.error = "Connection down";
        console.log("Failed to update status", e);
      }
    },
    async turnPagePopup() {
      const page = await this.$ons.openActionSheet({ 
        buttons: [...this.pages, "Cancel"],
        cancelable: true,
        title: "Select page"
      });
      if (page >= 0 && page < this.pages.length) {
        util.info(this, `Turning labels to page ${this.pages[page]}`);
        try {
          await this.$api.turnPage(page);
        } catch(e) {
          util.error(this, "Turning page failed", e);
        }
      }
    },
    async checkPages() {
      try {
        this.pages = await this.$api.getDisplayPages();
      } catch(e) {
        util.error(this, "Getting display pages failed", e);
      }
    }
  }
}
</script>

<style scoped>
.active {
  background-color: #bfd;
}
.error {
  background-color: #faa;
}
ons-card {
  text-align: center;
}
ons-button {
  margin: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  text-align: center;
  width: 80%;
  max-width: 15rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/HomePage.vue